import React, { useContext, useRef, useEffect, useState, useMemo } from 'react'
import { Row, Col, Container } from 'reactstrap'
import { FacetSidebar } from '../FacetSidebar/FacetSidebar'
import ProductListingGrid from './ProductListingGrid'
import { connect } from 'react-redux'
import * as R from 'ramda'
import qs from 'qs'
import {
  selectSubCategory,
  setPaginationFields,
  setProductRxLevel,
  setProductAvailability,
  setProductSortByFilter,
} from '../../actions'
import { withRouter } from 'react-router-dom'
import Paginate from '../Reusable/Paginate'
import NoProductsFound from '../Products/NoProductsFound'
import Paginator from '../../shared/components/Paginator'
import { Helmet } from 'react-helmet'
import { ShoppingContext } from '../../shared/ShoppingContext'
import '../FacetSidebar/listing.scss'
import './listing.scss'
import TransactionHOC from '../Reusable/TransactionHOC'

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}

const ProductListingPage = props => {
  const { width } = useWindowDimensions()
  const isMobile = useMemo(() => width <= '768px', [width])
  const { facetsForFiltering, setFacetsForFiltering } = useContext(ShoppingContext)
  const prevPropsRef = useRef()
  const { facets } = props.products
  const { validateRxAndAddToCart: validateRxAndAddToCartFromParent } = props
  const siblingCategories =
    props?.category?.children &&
    props?.category?.children.filter(child => child.id !== props?.categoryId)

  const handlePaginate = async page => {
    const searchObj = await props.getSearchObject()
    const sortBy = 'default'

    await updateUrlQuery(page)
    await props.getPagedPost(
      { ...searchObj, page, sortBy, facets: facetsForFiltering },
      props.PRODUCT_OBJ,
    )

    window.scrollTo(0, 0)
  }

  const resetFacetsAndProducts = async page => {
    const searchObj = await props.getSearchObject()
    const sortBy = 'default'

    await updateUrlQuery(page)
    const yup = await props.getPagedPost(
      { ...searchObj, page, sortBy, facets: {} },
      props.PRODUCT_OBJ,
    )
  }

  const restoreFilterData = async () => {
    const {
      setSearch,
      setSearchTerm,
      getShoppingFilters,
      getPagedPost,
      setCategoriesBySubCategoryUrl,
      PRODUCT_OBJ,
    } = props

    let queryObj = qs.parse(props.location.search, {
      ignoreQueryPrefix: true,
      decoder: function (str) {
        ////When stringifying obj to the url true became 'true' This is needed to parse string of 'true' to a value of true
        const strWithoutPlus = str.replace(/\+/g, ' ')
        const keywords = { true: true, false: false, null: null, undefined }
        if (str in keywords) return keywords[str]
        // utf-8
        try {
          return decodeURIComponent(strWithoutPlus)
        } catch (e) {
          return strWithoutPlus
        }
      },
    })

    if (queryObj.category === undefined) {
      queryObj.category = props.location.pathname.substring(
        props.location.pathname.lastIndexOf('/') + 1,
      )
    }
    const selectedSubCategory = queryObj.category
      ? await setCategoriesBySubCategoryUrl(queryObj.category)
      : {}
    const categoryId = R.pathOr('', ['id'], selectedSubCategory || {})

    if (queryObj.search) {
      await setSearchTerm(queryObj.search)
      await setSearch(queryObj.search)
    }

    const facets = queryObj.facetsForFiltering
    facets && setFacetsForFiltering(facets)

    const newQueryObj = {
      ...(queryObj.search ? { search: queryObj.search } : {}),
      ...(categoryId && !queryObj.search ? { categoryId } : {}),
      ...(facets ? { facets: facets } : {}),
    }

    getPagedPost(R.omit(['selected'], { sortBy: 'default', ...newQueryObj }), PRODUCT_OBJ)
    window.scrollTo(0, 0)
  }

  const onFacetSelectionChanged = async () => {
    const { getSearchObject, setShoppingFilter, getPagedPost, getShoppingFilters, PRODUCT_OBJ } =
      props

    const searchObj = { categoryId: props.categoryId, search: props.search }

    const queryObj = {
      ...searchObj,
      page: 1,
      sortBy: 'default',
      facets: facetsForFiltering,
    }
    updateUrlQuery()

    const shouldRunGetPagedPost =
      (facetsForFiltering && Object.keys(facetsForFiltering).length > 0) ||
      searchObj.categoryId ||
      searchObj.search

    //avoid running getPagedPost while async props are not available
    if (shouldRunGetPagedPost) {
      getPagedPost(
        { ...searchObj, page: 1, sortBy: 'default', facets: facetsForFiltering },
        PRODUCT_OBJ,
      )
    }
  }

  const updateUrlQuery = async (page = 1) => {
    const searchObj = await props.getSearchObject()

    const queryObj = {
      ...(searchObj?.search ? { search: searchObj?.search } : {}),
      page,
      ...searchObj,
      facetsForFiltering,
    }

    const queryString = qs.stringify(queryObj)

    props.history.push({ search: `?${queryString}` })
  }

  useEffect(() => {
    prevPropsRef.current = props
  })

  // useEffect(() => {
  //   const { searchTerm, filters, categoryId } = props
  //   const isNullOrEmpty = R.either(R.isNil, R.isEmpty)

  //   window.scrollTo(0, 0)

  //   const isRedirectedFromLogin = R.pathOr(false, ['location', 'redirectedFromLogin'], props)

  //   if (
  //     (isNullOrEmpty(searchTerm) && isNullOrEmpty(filters) && isNullOrEmpty(categoryId)) ||
  //     isRedirectedFromLogin
  //   ) {
  //     restoreFilterData()
  //   }
  // }, [props.location.pathname, props?.subcategory?.id])

  useEffect(() => {
    window.scrollTo(0, 0)
    restoreFilterData()
  }, [props.location.pathname])

  useEffect(() => {
    //update products with facet selection
    if (Object.keys(facetsForFiltering).length > 0) {
      onFacetSelectionChanged()
    }
  }, [facetsForFiltering])

  if (props.products.paginatedItems) {
    const products = R.pathOr(null, ['products', 'paginatedItems'], props)
    const productsData = R.pathOr(null, ['products'], props)
    const isPriceVisible = props.auth.user
      ? R.pathOr(false, ['auth', 'user', 'permissions', 'isPriceVisible'], props)
      : null
    const isAuthenticated = R.pathOr(false, ['auth', 'user', 'id'], props)
    const queryID = R.pathOr(null, ['products', 'queryID'], props)

    const notSearch = !R.isEmpty(props.categoryId)
    const categoryLabel = R.pathOr('', ['name'], props.category)
    const categoryId = R.pathOr('', ['id'], props.category)
    const categoryUrl = R.pathOr('', ['urlComponent'], props.category) || categoryId
    const subCategoryLabel = R.pathOr('', ['name'], props.subcategory)

    const breadcrumbs = notSearch
      ? props.subcategory && !R.isEmpty(props.subcategory)
        ? [{ path: `/category/${categoryUrl}`, text: categoryLabel }, { text: subCategoryLabel }]
        : [{ text: categoryLabel }]
      : []

    const categoryMetadescription = props.category.description
    const isSearch = props.executedSearchTerm && props.location.pathname === '/products/1'
    const searchTerm = props.executedSearchTerm
    const helmetTitle = props.category.name
      ? props.category.name + '-' + props.subcategory.name
      : isSearch
      ? 'Search Results'
      : props.location.pathname.split('/').pop()
    const categoryHelmetDescription = props.category.name
      ? `${props.subcategory.name} ${props.category.name}`
      : props.location.pathname.split('/').pop()
    const searchResultHelmetDescription = searchTerm && `Search Results for ${searchTerm}`
    const helmetDescription =
      categoryMetadescription ||
      searchResultHelmetDescription ||
      `Dealmed, providing the highest quality ${categoryHelmetDescription} on the market.`
    const removeFacet = facetToRemove => {
      const updatedFacets = Object.fromEntries(
        Object.entries(facetsForFiltering).map(([key, facets]) => [
          key,
          facets.filter(facet => facet !== facetToRemove),
        ]),
      )

      setFacetsForFiltering(updatedFacets)
    }

    const FacetDisplayChip = ({ facet }) => {
      return (
        <div className="listing__header-filters-item">
          {facet}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            onClick={() => removeFacet(facet)}
            style={{ cursor: 'pointer' }}
          >
            <title>close</title>
            <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
          </svg>
        </div>
      )
    }

    if (R.isEmpty(props.products)) {
      return (
        <div>
          <NoProductsFound categoryId={categoryId} search={searchTerm} />
        </div>
      )
    }

    return (
      <>
        <Helmet>
          <meta name="keywords" content={helmetTitle.split('-')} />
          <meta name="robots" content="index,follow" />
          <meta name="description" content={helmetDescription} />
          <title>Dealmed | {helmetTitle}</title>
          <link rel="canonical" href={`https://dealmed.com${props.history.location.pathname}`} />
        </Helmet>
        <div style={{ backgroundColor: '#F4F3F1' }}>
          <div className="listing__breadcrumbs">
            <div className="breadcrumb-block plp-breadcrumb-banner">
              <div className="dealmed-container">
                {breadcrumbs.length > 0 ? (
                  <div className="bb__steps mb-0">
                    <a className="bb__steps--noactive" href="/">
                      Home
                    </a>
                    {/* <p className="bb__steps--deco">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>chevron-right</title><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>
                    </p> */}
                    {/* <a
                      className="bb__steps--noactive"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        props.history.push(breadcrumbs[0].path)
                      }}
                    >
                      {breadcrumbs[0].text} 
                    </a> */}
                    <p className="bb__steps--deco">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>chevron-right</title>
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                      </svg>
                    </p>
                    <p className="bb__steps--active" href="">
                      {breadcrumbs[1].text}
                    </p>
                  </div>
                ) : null}
              </div>
            </div>

            {isSearch ? (
              <div className="breadcrumb-block bb" style={{ padding: '0px', marginTop: '16px' }}>
                <div className="dealmed-container">
                  <div className="bb__name">
                    <h2 className="bb__name-heading mb-10">Search Results for: "{searchTerm}"</h2>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          <div className="dealmed-container">
            {/* <Container style={{ padding: isMobile ? '0px' : null }}> */}
            {/* <Row style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: '15px' }}>
              {props?.products?.paginatedItems?.length > 0 && (
                <Paginator category="products" handlePaginate={handlePaginate} />
              )}
            </Row> */}
            <Row style={{ flexDirection: isMobile ? 'column' : null }}>
              <Col xs={12} md={4} lg={3}>
                <FacetSidebar
                  facets={facets}
                  siblingCategories={siblingCategories}
                  products={products}
                  productsData={productsData}
                  searchTerm={props.searchTerm}
                  categoryLabel={categoryLabel}
                  resetFacetsAndProducts={resetFacetsAndProducts}
                />
              </Col>
              <Col xs={12} md={8} lg={9}>
                <div className="listing__header">
                  <div className="listing__header-filters" style={{ overflowX: 'scroll' }}>
                    {Object.values(facetsForFiltering).flat().length > 0 &&
                      Object.values(facetsForFiltering)
                        .flat()
                        .filter(facet => facet !== '')
                        .map((facet, index) => <FacetDisplayChip key={index} facet={facet} />)}
                  </div>
                  {/* item number need to be implemented */}
                  {/* <select className="listing__header-itemnum" name="itemNum" id="cars">
                        <option value="12">12</option>
                        <option value="24">24</option>
                        <option value="48">48</option>
                        <option value="96">96</option>
                      </select> */}
                </div>
                {
                  <ProductListingGrid
                    products={products}
                    isPriceVisible={isPriceVisible}
                    isAuthenticated={isAuthenticated}
                    isLoading={props.products.isLoading}
                    searchTerm={props.searchTerm}
                    queryID={queryID}
                    validateRxAndAddToCartFromParent={validateRxAndAddToCartFromParent}
                  />
                }
                <div
                  className="dealmed-products__footer"
                  style={{ justifyContent: 'center', margin: '40px 0' }}
                >
                  {props?.products?.paginatedItems?.length > 0 && (
                    <div className="dealmed-products__paginator">
                      <Paginator category="products" handlePaginate={handlePaginate} />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            {/* </Container> */}
          </div>
        </div>
      </>
    )
  }

  return null
}

const mapStateToProps = ({
  auth,
  loader,
  paginate,
  shopping: {
    filters = {},
    searchTerm = '',
    search,
    selectedCategory = {},
    selectedSubCategory = {},
    setProductRxLevel,
    setProductAvailability,
    setProductSortByFilter,
    subCategories = [],
    categories,
  },
}) => {
  return {
    auth: auth,
    attr: paginate.products.attr,
    filters: filters,
    search: searchTerm,
    executedSearchTerm: search,
    category: selectedCategory,
    subcategory: selectedSubCategory,
    setProductRxLevel,
    setProductAvailability,
    setProductSortByFilter,
    categoryId: R.pathOr('', ['id'], selectedSubCategory),
    subCategories: subCategories,
    categories: categories,
    isLoadingMoreProducts: loader.isLoadingMoreProducts,
  }
}

export default TransactionHOC(
  Paginate(
    connect(mapStateToProps, {
      selectSubCategory,
      setPaginationFields,
      setProductRxLevel,
      setProductAvailability,
      setProductSortByFilter,
    })(withRouter(ProductListingPage)),
  ),
)
